const packageSubmissionActions = {
  ADD_JOB_PACKAGE: 'ADD_JOB_PACKAGE' as const,
  ADD_CANDIDATE_SEARCH_PACKAGE: 'ADD_CANDIDATE_SEARCH_PACKAGE' as const,
  ADD_SOCIAL_POSTING_PACKAGE: 'ADD_SOCIAL_POSTING_PACKAGE' as const,
  ADD_HIGHLIGHTED_PACKAGE: 'ADD_HIGHLIGHTED_PACKAGE' as const,
  ADD_TOP_RESULT_PACKAGE: 'ADD_TOP_RESULT_PACKAGE' as const,
  REMOVE_PACKAGE: 'REMOVE_PACKAGE' as const,
  UPDATE_PAYMENT_DETAILS: 'UPDATE_PAYMENT_DETAILS' as const,
  RESET_ORDER: 'RESET_ORDER' as const,
  TOGGLE_UPSALE_VISIBLE: 'TOGGLE_UPSALE_VISIBLE' as const,
};

export default packageSubmissionActions;
